import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule, ImgModule } from '@coreui/angular-pro';
import { ServerAuthUrlPipe } from 'auth';

import moment from 'moment';
import { Logger } from 'shared';

@Component({
  selector: 'calendar-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  imports: [ CommonModule, ButtonModule, ImgModule, ServerAuthUrlPipe ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalendarEventListComponent {

  @Input() events: any[] = [];
  @Output() select = new EventEmitter<any>();

  protected logger = new Logger('CalendarEventListComponent');
  
  constructor() {
    this.logger = new Logger('CalendarEventListComponent');
  }
  
  onEventClick(event: any) {
    this.select.emit(event);
    // if (event.media) {
    //   const type = event.media.type;
    //   if (type === 'conference' || type === 'media') {
    //     const language = this.userService.getLanguage();
    //     this.router.navigate([`/${language}/${type}`], { state: { data: event.media }});
    //   } else {
    //     this.logger.error(`Invalid media type: ${type}`);
    //   }
    // }
  }

  formatDate(timestamp: number): string {
    const date = new Date(timestamp);
    return moment(date).format('MMM D, HH:mm').toString();
    // return date.toLocaleString('en-US', {
    //   year: 'numeric',
    //   month: 'short',
    //   day: 'numeric',
    //   hour: '2-digit',
    //   minute: '2-digit',
    //   // second: '2-digit'
    // });
  }
}